export default __webpack_public_path__ + "static/media/C250251.fdaba667.jpg";